import React from 'react';
import ModalHeader from "@img/Modal7Top.jpg";

const ModalStep2 = ({ onNext }) => {
    return (
        <>
            <div>
                <img src={ModalHeader} alt='' className='mb-8'></img>
                <button
                    type="button"
                    className="w-full text-white bg-[#1c75ac] hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-[#1c75ac] font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                    onClick={onNext}
                >
                    Lewati
                </button>
            </div>
        </>
    );
};

export default ModalStep2;
